/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';
const hideHoverLine = {

	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {
		if ($('.cards__content--resources>.cards__inner-more').length === 0) {
			$('.cards__content--resources>.cards__inner-more').closest('.cards__inner').removeClass('hide-line');
		} else {
			$('.cards__content--resources').closest('.cards__inner').addClass('hide-line');
			$('.cards__content--resources>.cards__inner-more').closest('.cards__inner').removeClass('hide-line');
		}
	},
};

export default hideHoverLine;
